if (!customElements.get('standalone-products')) {
  customElements.define('standalone-products', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.grid = this.querySelector('[data-standalone-grid]');
      this.heading = this.querySelector('[data-standalone-heading]');
      this.pagination = this.querySelector('[data-standalone-pagination]');
      this.status = this.querySelector('[data-standalone-status]');
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-standalone-next]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0 || this.failed) return;
        event.preventDefault();
        this.loadMore();
      });
      if (this.grid.children.length === 0 && this.pagination.querySelector('a')) this.loadMore();
    }

    async loadMore() {
      if (this.loading) return;
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.status.dataset.loading;
      const initialCount = this.grid.children.length;
      const visited = new Set();
      try {
        while (this.grid.children.length === initialCount) {
          const link = this.pagination.querySelector('[data-standalone-next]');
          if (!link) break;
          const url = new URL(link.href, window.location.href);
          if (visited.has(url.href)) throw new Error('Repeated pagination URL');
          visited.add(url.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url.href);
          if (!response.ok) throw new Error('Unable to load products');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = [...document.querySelectorAll('standalone-products')].find((element) => element.dataset.sectionId === this.dataset.sectionId);
          if (!next) throw new Error('Missing product section');
          const existingIds = new Set([...this.grid.children].map((item) => item.dataset.standaloneProduct));
          for (const card of next.querySelector('[data-standalone-grid]').children) {
            if (!existingIds.has(card.dataset.standaloneProduct)) {
              existingIds.add(card.dataset.standaloneProduct);
              this.grid.append(card.cloneNode(true));
            }
          }
          this.pagination.replaceChildren(...next.querySelector('[data-standalone-pagination]').childNodes);
        }
        this.heading.hidden = this.grid.children.length === 0;
        this.hidden = this.grid.children.length === 0 && !this.pagination.querySelector('a');
        this.dataset.count = String(this.grid.children.length);
      } catch {
        this.failed = true;
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
        this.status.textContent = '';
      }
    }
  });
}
